import { Select } from 'antd';
import React, { useState, useEffect } from 'react';
import './projectTypeFilter.scss';
import { API } from '@service';

const { Option } = Select;

export const PROJECT_TYPES = {
  ALL_PROJECT: 'All Projects',
  // SELL_SIDE: 'Sell-Side',
  // BUY_SIDE: 'Buy-Side',
  TEST_PROJECTS: 'Test Project',
};

// export function filterMapper(filter) {
//   if (filter === PROJECT_TYPES.BUY_SIDE) {
//     return 'Integration';
//   } else if (filter === PROJECT_TYPES.SELL_SIDE) {
//     return 'Divestiture';
//   }
// }

// const isType = (type) => (e) => e.companyInstance === filterMapper(type);
const isTest = (e) => e.isInternalUseOnly;

const getOptionsByProjectList = (data = [], projectTypes) => {
  let hasTestFlag = false;
  //  hasBuySideFlag = false,
  //   hasSellSideFlag = false,
  // hasTestFlag = false;

  return data.reduce(
    (acc, e) => {
      if (
        acc.findIndex((type) => type === e.instanceName) === -1 &&
        projectTypes.findIndex((type) => type.id === e.companyInstance) > -1
      ) {
        acc = [...acc, e.instanceName];
      }
      if (!hasTestFlag && isTest(e)) {
        acc = [...acc, PROJECT_TYPES.TEST_PROJECTS];
        hasTestFlag = true;
      }
      return acc;
    },
    [PROJECT_TYPES.ALL_PROJECT],
  );
};

export function ProjectTypeFilter({ filter, data, onChange }) {
  const [projectTypes, setProjectTypes] = useState([]);

  const options = getOptionsByProjectList(data, projectTypes);

  const getAllTypes = async () => {
    const types = (await API.getAllProjectInstances()) || [];
    setProjectTypes(types.filter((t) => !t.isDeleted));
  };

  useEffect(() => {
    getAllTypes();
  }, []);

  return (
    <Select
      className="project-type-filter"
      value={filter}
      onChange={(e) => {
        onChange(e);
      }}
      dropdownClassName="dropdown-of-project-filter"
    >
      {options.map((opt) => (
        <Option key={opt} value={opt}>
          {opt}
        </Option>
      ))}
    </Select>
  );
}
